'use client'

import { useState } from 'react'
import { FaCheck, FaTimes, FaKey } from 'react-icons/fa'
import { toast } from "react-toastify"
import { useNavigate } from 'react-router-dom'
import { API_BASE_URL } from '../utils/CONSTANTS'
import axios from 'axios';
export default function ChangePassword() {
  const [isMaximized, setIsMaximized] = useState(false)
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    reTypePassword: '',
    role:""
  })

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSave = async (e) => {
    e.preventDefault()

    if (formData.newPassword !== formData.reTypePassword) {
      return toast("Error: password and confirm password arent the same");
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/changepass`,formData, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": `${API_BASE_URL}`
        },
        credentials: "include",
        
      });
      console.log(response)
      

      if (response.status === 200) {
        toast.success("Password changed successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
        navigate("/login");

      }
    } catch (err) {
      console.log(err);


      
        alert(err.response.data?.message, );  
        return;
    }

  }

  return (
    <div className=" p-1 flex items-center justify-center">
      <div className={`bg-gray-200 shadow-xl ${isMaximized ? 'w-full h-full' : 'w-[400px]'}`}>

        <div className="flex items-center justify-between px-2 py-0.5 bg-gradient-to-r from-[#0e3131] via-[#04545f] to-[#0a8793] text-white">
          <div className="flex items-center gap-1">
            <FaKey className="w-2 h-2" />
            <span className="text-xs ">Change Password</span>
          </div>
          <div className="flex">
            {/* <button className="px-2 py-0.5 hover:bg-blue-500">
              <span className="text-xs">−</span>
            </button> */}
            <button
              className="px-2 py-0.5 hover:bg-blue-500"
              onClick={() => setIsMaximized(!isMaximized)}
            >
              <span className="text-xs">□</span>
            </button>
            {/* <button className="px-2 py-0.5 hover:bg-red-500">
              <span className="text-xs">×</span>
            </button> */}
          </div>
        </div>

        {/* Main Content */}
        <form onSubmit={handleSave}>
          <div className="p-2 bg-[#E6FFFF] space-y-4">
            <div className="grid grid-cols-[110px_1fr] items-center gap-1">
              <label className="text-xs font-medium text-gray-700">Role</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="w-full px-1 py-1 border border-gray-300 rounded text-sm"
              >
                <option value="">Select user type</option>
                <option value="superadmin">Super Admin</option>
                <option value="admin">Admin</option>
                <option value="packer">Packer</option>
                <option value="qc">QC</option>
                <option value="user">User</option>
              </select>
            </div>
            <div className="grid grid-cols-[110px_1fr] items-center gap-1">
              <label className="text-xs font-medium text-gray-700">Old Password</label>
              <input
                type="password"
                name="oldPassword"
                value={formData.oldPassword}
                onChange={handleChange}
                className="w-full px-1 py-1 border border-gray-300 rounded text-sm"
              />
            </div>

            <div className="grid grid-cols-[110px_1fr] items-center gap-2">
              <label className="text-xs font-medium text-gray-700">New Password</label>
              <input
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
              />
            </div>

            <div className="grid grid-cols-[110px_1fr] items-center gap-2">
              <label className="text-xs font-medium text-gray-700">Re-Type Password</label>
              <input
                type="password"
                name="reTypePassword"
                value={formData.reTypePassword}
                onChange={handleChange}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center gap-1 p-1 bg-teal-700">
            <button
              type="submit"
              className="flex items-center gap-1 px-2 py-1 bg-gray-100 hover:bg-gray-200 border rounded border-gray-400 text-sm"
              onClick={handleSave}
            >
              <FaCheck className="w-3 h-3 text-xs  text-green-600" />
              Save
            </button>
            <button
              type="button"
              className="flex items-center gap-1 px-2 py-1 bg-gray-100 hover:bg-gray-200 border rounded border-gray-400 text-sm"
            >
              <FaTimes className="w-3 h-3 text-xs  text-red-600" />
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

